"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CfgTrustZoneEditor_1 = require("./component/CfgTrustZoneEditor");
var CfgTrustZonesList_1 = require("./component/CfgTrustZonesList");
var PCfgTrustZonesList = /** @class */ (function (_super) {
    __extends(PCfgTrustZonesList, _super);
    function PCfgTrustZonesList(props) {
        return _super.call(this, props) || this;
    }
    PCfgTrustZonesList.prototype.componentWillMount = function () {
        //this.SID_TT = this.props.tagTypesData.Subscribe("*", (id, data) => {
        //    this.setState({
        //        avail_tagtypes: data.data
        //    });
        //});
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            // avail_tagtypes: [],
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            // this.props.tagTypesData.LoadData();
        });
    };
    PCfgTrustZonesList.prototype.componentWillUnmount = function () {
        //this.props.tagTypesData.UnSubscribe(this.SID_TT);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCfgTrustZonesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgTrustZonesList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgTrustZonesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgTrustZonesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgTrustZonesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgTrustZoneEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgTrustZoneEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgTrustZonesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgTrustZonesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgTrustZonesList.getPageDescription = function (state) {
        return {
            icon: "check-double",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_config_trust_zones + "-id",
            itemTitle: "Зоны доверия",
            route: routes_1.routes.page_config_trust_zones,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgTrustZonesList;
}(React.Component));
exports.default = PCfgTrustZonesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_trust_zones/ui/PCfgTrustZonesList.tsx
// module id = 2578
// module chunks = 0